import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url.to-json.js";
import "core-js/modules/web.url-search-params.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import AssetIcon from 'components/AssetIcon';
import ThumbnailUploader from 'components/ThumbnailUploader';
import CardImage from 'components/CardImage';
import { getContentItemIconFromType } from 'utils/icons';
import getContentItemType from 'utils/asset/getContentItemType';
import getPictureUrl, { DIMENSIONS } from 'utils/image/getPictureUrl';
import { setAlert, setSuccessAlert } from 'actions/alerts';
import { useUploadFile } from 'actions/file';
import ImagePreviewModal from './ImagePreviewModal';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export function ThumbnailEditor(_ref) {
  var isDisabled = _ref.isDisabled,
    _ref$isMultiSelectWit = _ref.isMultiSelectWithThumbnails,
    isMultiSelectWithThumbnails = _ref$isMultiSelectWit === void 0 ? false : _ref$isMultiSelectWit,
    _ref$setThumbnailRefe = _ref.setThumbnailReferenceOnUpload,
    setThumbnailReferenceOnUpload = _ref$setThumbnailRefe === void 0 ? false : _ref$setThumbnailRefe,
    _ref$hasUploadSuccess = _ref.hasUploadSuccessAlert,
    hasUploadSuccessAlert = _ref$hasUploadSuccess === void 0 ? true : _ref$hasUploadSuccess,
    id = _ref.id,
    content = _ref.content,
    aspectRatio = _ref.aspectRatio,
    _ref$dimensions = _ref.dimensions,
    dimensions = _ref$dimensions === void 0 ? DIMENSIONS.VERTICAL_CARD : _ref$dimensions,
    maxHeight = _ref.maxHeight,
    onUploadThumbnail = _ref.onUploadThumbnail,
    onRemoveThumbnail = _ref.onRemoveThumbnail;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var contentId = content.id,
    thumbnailId = content.thumbnailId,
    fileType = content.fileType;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isPreviewModalOpen = _useState2[0],
    setPreviewModalOpen = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    file = _useState4[0],
    setFile = _useState4[1];
  var isPlaylist = content.fileType === 'playlist-thumbnail';
  var isTopic = content.fileType === 'topic-thumbnail';
  var rawType = getContentItemType(content);
  var icon;
  if (isPlaylist) {
    icon = 'playlist';
  } else if (isTopic) {
    icon = 'topic';
  } else {
    icon = getContentItemIconFromType(rawType);
  }
  var _useUploadFile = useUploadFile({
      onSetAlert: function onSetAlert(options) {
        return setAlert(_objectSpread({
          key: 'upload-cover-image',
          title: t('alert_uploading_cover_image')
        }, options));
      }
    }),
    uploadFile = _useUploadFile.uploadFile;
  function uploadThumbnailFile(_x) {
    return _uploadThumbnailFile.apply(this, arguments);
  }
  function _uploadThumbnailFile() {
    _uploadThumbnailFile = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(file) {
      var ids, res, _t;
      return _regeneratorRuntime.wrap(function (_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            ids = contentId ? Array.isArray(contentId) ? contentId : [contentId] : undefined;
            _context2.prev = 1;
            _context2.next = 2;
            return uploadFile({
              type: fileType,
              file: file,
              referenceIds: setThumbnailReferenceOnUpload ? ids : undefined
            });
          case 2:
            res = _context2.sent;
            if (res.fileId) {
              _context2.next = 3;
              break;
            }
            return _context2.abrupt("return");
          case 3:
            if (hasUploadSuccessAlert) {
              setSuccessAlert({
                title: t('alert_cover_image_uploaded')
              });
            }
            onUploadThumbnail(res.fileId);
            _context2.next = 5;
            break;
          case 4:
            _context2.prev = 4;
            _t = _context2["catch"](1);
            setAlert({
              title: t('error_500')
            });
          case 5:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[1, 4]]);
    }));
    return _uploadThumbnailFile.apply(this, arguments);
  }
  var onUpload = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref2) {
      var file;
      return _regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            file = _ref2.file;
            if (!isPlaylist) {
              _context.next = 1;
              break;
            }
            // Get file for preview
            setFile(Object.assign(file, {
              previewUrl: URL.createObjectURL(file)
            }));
            setPreviewModalOpen(true);
            _context.next = 2;
            break;
          case 1:
            _context.next = 2;
            return uploadThumbnailFile(file);
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function onUpload(_x2) {
      return _ref3.apply(this, arguments);
    };
  }();
  useEffect(function () {
    // Make sure to revoke the data uris to avoid memory leaks, will run on unmount
    if (file !== null && file !== void 0 && file.previewUrl) {
      URL.revokeObjectURL(file === null || file === void 0 ? void 0 : file.previewUrl);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  var canShowPreview = content.thumbnailId || (file === null || file === void 0 ? void 0 : file.previewUrl);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(CardImage, {
      lazyload: false,
      src: getPictureUrl({
        id: thumbnailId,
        dimensions: dimensions
      }),
      colorBlock: icon,
      aspectRatio: aspectRatio || 5 / 12,
      minHeight: 120,
      maxHeight: maxHeight,
      fallbackContent: /*#__PURE__*/_jsx(AssetIcon, {
        name: icon,
        size: "big"
      }),
      borderRadius: "large",
      children: /*#__PURE__*/_jsx(ThumbnailUploader, {
        isMultiSelectWithThumbnails: isMultiSelectWithThumbnails,
        id: id,
        data: content,
        uploadThumbnail: onUpload,
        removeThumbnail: onRemoveThumbnail,
        previewThumbnail: canShowPreview ? function () {
          return setPreviewModalOpen(true);
        } : undefined,
        isDisabled: isDisabled
      })
    }), isPreviewModalOpen && canShowPreview && /*#__PURE__*/_jsx(ImagePreviewModal, {
      isDisabled: isDisabled,
      previewUrl: file === null || file === void 0 ? void 0 : file.previewUrl,
      content: content,
      fileType: fileType,
      onReset: function onReset() {
        return setFile(null);
      },
      onClose: function onClose() {
        setPreviewModalOpen(false);
        setFile(null);
      },
      onUpload: function onUpload() {
        file && uploadThumbnailFile(file);
        setFile(null);
      },
      onReplace: onUpload
    })]
  });
}
export default ThumbnailEditor;